import { ReactElement } from "react";

export interface CheckLabelProps {
  checked: boolean;
}

export function CheckLabel({ checked }: CheckLabelProps): ReactElement | null {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{checked && "✓"}</>;
}
